import { z } from 'zod';

export const incidentSchema = z.object({
  title: z.string().min(3, 'Le titre doit faire au moins 3 caracteres'),
  severity: z.enum(['critical', 'major', 'minor', 'info']),
  affectedServices: z.array(z.string()).min(1, 'Selectionnez au moins un service'),
  description: z.string().min(10, 'La description doit faire au moins 10 caracteres'),
  status: z.enum(['investigating', 'identified', 'monitoring', 'resolved']),
});
export type IncidentFormData = z.infer<typeof incidentSchema>;

export const incidentUpdateSchema = z.object({
  message: z.string().min(5, 'Le message doit faire au moins 5 caracteres'),
  status: z.enum(['investigating', 'identified', 'monitoring', 'resolved']),
});
export type IncidentUpdateFormData = z.infer<typeof incidentUpdateSchema>;

export const maintenanceSchema = z.object({
  title: z.string().min(3, 'Le titre doit faire au moins 3 caracteres'),
  description: z.string().min(10, 'La description doit faire au moins 10 caracteres'),
  affectedServices: z.array(z.string()).min(1, 'Selectionnez au moins un service'),
  scheduledStartAt: z.string().min(1, 'La date de debut est requise'),
  scheduledEndAt: z.string().min(1, 'La date de fin est requise'),
});
export type MaintenanceFormData = z.infer<typeof maintenanceSchema>;

export const announcementSchema = z.object({
  title: z.string().min(3, 'Le titre doit faire au moins 3 caracteres'),
  content: z.string().min(10, 'Le contenu doit faire au moins 10 caracteres'),
  type: z.enum(['info', 'feature', 'update', 'warning']),
  isActive: z.boolean(),
  startsAt: z.string().min(1, 'La date de debut est requise'),
  endsAt: z.string().optional(),
});
export type AnnouncementFormData = z.infer<typeof announcementSchema>;

export const emailCampaignSchema = z.object({
  subject: z.string().min(3, "L'objet doit faire au moins 3 caracteres"),
  content: z.string().min(10, 'Le contenu doit faire au moins 10 caracteres'),
  recipientFilter: z.enum(['all', 'active', 'inactive', 'trial', 'custom']),
  scheduledAt: z.string().optional(),
});
export type EmailCampaignFormData = z.infer<typeof emailCampaignSchema>;
